import { mapSagasFromConfigurations } from '../../helpers/sagas';
import { configurations } from './configurations';

function* globalSagas() {
  yield mapSagasFromConfigurations('onboarding')(configurations)
}

export default globalSagas;



// WEBPACK FOOTER //
// ./src/state/modules/global/sagas.js